import React, { useState,useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { Link } from '@mui/material';
import './classes/ViewScoutingRequests.css';
import SalespersonSidebar from "./SalespersonSidebar";
import { Pagination, Box } from "@mui/material";
import Loading from './Loading';
import { configData } from "../config";

// === Columns
const columns = [
  { field: "sport", headerName: "Player's Sport", flex: 1 },
  { field: "player", headerName: "Player", flex: 1 },
  { field: "age", headerName: "Player's Age", flex: 1 },
  { field: "team", headerName: "Player's Team", flex: 1 },
  { field: "position", headerName: "Player's Position", flex: 1 },
  { field: "location", headerName: "Player's Location", flex: 1 },
  { field: "date", headerName: "Date Requested", flex: 1 },
  { field: "requester", headerName: "Requester", flex: 1 },
  { field: "relation", headerName: "Requester's Relationship to Player", flex: 1 },
  {
    field: 'view',
    headerName: ' ',
    flex:1,  
    renderCell: (params) => (
      <Link href={"/node/841/submission/"+params.row.id} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        View
      </Link>
    ),
  },
];

// === Sport Map
const sportMap = {
  1: "Football (American)",
  2: "Baseball",
  3: "Basketball",
  4: "Soccer",
  6: "Hockey",
  8: "Cricket",
  46: "Rugby",
};

 const sportOrder = ["All", ...Object.values(sportMap)];

// Example data (You should replace this with actual data)
/* const scoutingData = [
  // Add more test records here
    { id: 1, sport: "Football (American)", player: "John Doe", age: 18, team: "Eagles", position: "Quarterback", location: "Texas", date: "2025-01-01", requester: "Coach Mike", relation: "Coach" },
  { id: 2, sport: "Football (American)", player: "Alex Smith", age: 19, team: "Lions", position: "Linebacker", location: "California", date: "2025-01-02", requester: "Coach Steve", relation: "Trainer" },
  { id: 3, sport: "Football (American)", player: "Ethan Hunt", age: 20, team: "Panthers", position: "Wide Receiver", location: "Ohio", date: "2025-01-03", requester: "Coach Ray", relation: "Uncle" },
  { id: 4, sport: "Football (American)", player: "Logan Paul", age: 21, team: "Giants", position: "Tight End", location: "Nevada", date: "2025-01-04", requester: "Scout Tim", relation: "Coach" },
  { id: 5, sport: "Football (American)", player: "Jake Paul", age: 22, team: "Sharks", position: "Running Back", location: "Arizona", date: "2025-01-05", requester: "Dad", relation: "Father" },
  { id: 6, sport: "Baseball", player: "Tom Hardy", age: 18, team: "Tigers", position: "Pitcher", location: "Florida", date: "2025-01-06", requester: "Coach Sam", relation: "Coach" },
  { id: 7, sport: "Baseball", player: "Chris Evans", age: 19, team: "Mets", position: "Catcher", location: "New York", date: "2025-01-07", requester: "Coach Kyle", relation: "Uncle" },
  { id: 8, sport: "Baseball", player: "Matt Damon", age: 20, team: "Yankees", position: "Shortstop", location: "New York", date: "2025-01-08", requester: "Scout Lily", relation: "Cousin" },
  { id: 9, sport: "Baseball", player: "Ben Affleck", age: 21, team: "Rangers", position: "First Base", location: "Texas", date: "2025-01-09", requester: "Coach Alex", relation: "Friend" },
  { id: 10, sport: "Baseball", player: "Mark Wahlberg", age: 22, team: "Cubs", position: "Third Base", location: "Illinois", date: "2025-01-10", requester: "Coach Tom", relation: "Mentor" },
  { id: 11, sport: "Basketball", player: "Kobe Lee", age: 18, team: "Lakers", position: "Point Guard", location: "California", date: "2025-01-11", requester: "Coach Dan", relation: "Coach" },
  { id: 12, sport: "Basketball", player: "Michael Jay", age: 19, team: "Bulls", position: "Shooting Guard", location: "Illinois", date: "2025-01-12", requester: "Coach James", relation: "Cousin" },
  { id: 13, sport: "Basketball", player: "LeBron Stone", age: 20, team: "Cavaliers", position: "Small Forward", location: "Ohio", date: "2025-01-13", requester: "Coach Frank", relation: "Friend" },
  { id: 14, sport: "Basketball", player: "Stephen Rock", age: 21, team: "Warriors", position: "Shooting Guard", location: "California", date: "2025-01-14", requester: "Coach Gary", relation: "Uncle" },
  { id: 15, sport: "Basketball", player: "Shaq Max", age: 22, team: "Heat", position: "Center", location: "Florida", date: "2025-01-15", requester: "Coach Vic", relation: "Coach" },
  { id: 16, sport: "Soccer", player: "Leo Cruz", age: 18, team: "Galaxy", position: "Forward", location: "California", date: "2025-01-16", requester: "Coach Albert", relation: "Coach" },
  { id: 17, sport: "Soccer", player: "Cristian Gold", age: 19, team: "FC Miami", position: "Midfielder", location: "Florida", date: "2025-01-17", requester: "Coach Leo", relation: "Uncle" },
  { id: 18, sport: "Soccer", player: "Ney Morrow", age: 20, team: "NYC FC", position: "Forward", location: "New York", date: "2025-01-18", requester: "Coach Dan", relation: "Friend" },
  { id: 19, sport: "Soccer", player: "Messi King", age: 21, team: "Chicago Fire", position: "Striker", location: "Illinois", date: "2025-01-19", requester: "Coach Dave", relation: "Coach" },
  { id: 20, sport: "Soccer", player: "Ronaldo Peace", age: 22, team: "LA FC", position: "Midfielder", location: "California", date: "2025-01-20", requester: "Coach Rob", relation: "Cousin" },
  { id: 21, sport: "Hockey", player: "Wayne Snow", age: 18, team: "Maple Leafs", position: "Center", location: "Toronto", date: "2025-01-21", requester: "Coach Ken", relation: "Coach" },
  { id: 22, sport: "Hockey", player: "Sid Ice", age: 19, team: "Penguins", position: "Right Wing", location: "Pittsburgh", date: "2025-01-22", requester: "Coach Carl", relation: "Friend" },
  { id: 23, sport: "Hockey", player: "Connor Stick", age: 20, team: "Oilers", position: "Left Wing", location: "Edmonton", date: "2025-01-23", requester: "Coach Vic", relation: "Uncle" },
  { id: 24, sport: "Hockey", player: "Alex Skate", age: 21, team: "Capitals", position: "Defense", location: "Washington", date: "2025-01-24", requester: "Coach Drew", relation: "Coach" },
  { id: 25, sport: "Hockey", player: "Marc Freeze", age: 22, team: "Canadiens", position: "Goalie", location: "Montreal", date: "2025-01-25", requester: "Coach Rick", relation: "Father" },
  { id: 26, sport: "Cricket", player: "Virat Kumar", age: 26, team: "Delhi Capitals", position: "Batsman", location: "India", date: "2025-01-26", requester: "Coach Raju", relation: "Coach" },
  { id: 27, sport: "Cricket", player: "MS Singh", age: 28, team: "CSK", position: "Wicket Keeper", location: "India", date: "2025-01-27", requester: "Coach Ravi", relation: "Mentor" },
  { id: 28, sport: "Cricket", player: "Rohit Shetty", age: 29, team: "MI", position: "Batsman", location: "India", date: "2025-01-28", requester: "Coach Ajay", relation: "Uncle" },
  { id: 29, sport: "Cricket", player: "Jasprit Boom", age: 27, team: "RCB", position: "Bowler", location: "India", date: "2025-01-29", requester: "Coach Hari", relation: "Coach" },
  { id: 30, sport: "Cricket", player: "KL Raj", age: 25, team: "KKR", position: "Batsman", location: "India", date: "2025-01-30", requester: "Coach Sam", relation: "Cousin" },
  { id: 31, sport: "Rugby", player: "Jack Maul", age: 24, team: "Stormers", position: "Prop", location: "Cape Town", date: "2025-01-31", requester: "Coach Adam", relation: "Coach" },
  { id: 32, sport: "Rugby", player: "Tom Scrum", age: 25, team: "Sharks", position: "Lock", location: "Durban", date: "2025-02-01", requester: "Coach Phil", relation: "Father" },
  { id: 33, sport: "Rugby", player: "Harry Pass", age: 26, team: "Bulls", position: "Fly-half", location: "Pretoria", date: "2025-02-02", requester: "Coach Luke", relation: "Uncle" },
  { id: 34, sport: "Rugby", player: "Mike Tackle", age: 27, team: "Cheetahs", position: "Hooker", location: "Bloemfontein", date: "2025-02-03", requester: "Coach Tim", relation: "Mentor" },
  { id: 35, sport: "Rugby", player: "Sam Try", age: 28, team: "Lions", position: "Fullback", location: "Johannesburg", date: "2025-02-04", requester: "Coach Dave", relation: "Coach" },
  { id: 36, sport: "Soccer", player: "Marco Goal", age: 19, team: "Real FC", position: "Goalkeeper", location: "Spain", date: "2025-02-05", requester: "Coach Ren", relation: "Uncle" },
  { id: 37, sport: "Basketball", player: "Julius Win", age: 23, team: "Nets", position: "Center", location: "Brooklyn", date: "2025-02-06", requester: "Coach Neal", relation: "Coach" },
  { id: 38, sport: "Baseball", player: "Luke Swing", age: 20, team: "Astros", position: "Outfield", location: "Houston", date: "2025-02-07", requester: "Coach Glen", relation: "Friend" },
  { id: 39, sport: "Football (American)", player: "Tony Blitz", age: 24, team: "Bears", position: "Safety", location: "Chicago", date: "2025-02-08", requester: "Coach Roy", relation: "Coach" },
  { id: 40, sport: "Hockey", player: "Zack Chill", age: 21, team: "Jets", position: "Winger", location: "Winnipeg", date: "2025-02-09", requester: "Coach Omar", relation: "Coach" },
  { id: 41, sport: "Cricket", player: "Anil Pace", age: 24, team: "SRH", position: "Bowler", location: "India", date: "2025-02-10", requester: "Coach Ravi", relation: "Uncle" },
  { id: 42, sport: "Rugby", player: "Ron Ruck", age: 29, team: "Bulls", position: "Wing", location: "South Africa", date: "2025-02-11", requester: "Coach Finn", relation: "Coach" },
  { id: 43, sport: "Soccer", player: "Carlos Foot", age: 20, team: "Inter", position: "Defender", location: "Italy", date: "2025-02-12", requester: "Coach Tony", relation: "Cousin" },
  { id: 44, sport: "Basketball", player: "Dwayne Dunk", age: 22, team: "Heat", position: "Forward", location: "Miami", date: "2025-02-13", requester: "Coach Walt", relation: "Friend" },
  { id: 45, sport: "Baseball", player: "Owen Hit", age: 21, team: "Dodgers", position: "Pitcher", location: "LA", date: "2025-02-14", requester: "Coach Terry", relation: "Coach" },
  { id: 46, sport: "Football (American)", player: "Paul Pass", age: 23, team: "Packers", position: "Cornerback", location: "Wisconsin", date: "2025-02-15", requester: "Coach Mike", relation: "Mentor" },
  { id: 47, sport: "Cricket", player: "Ravi Spin", age: 26, team: "GT", position: "All-Rounder", location: "India", date: "2025-02-16", requester: "Coach Sanjay", relation: "Coach" },
  { id: 48, sport: "Hockey", player: "Danny Blade", age: 25, team: "Bruins", position: "Defense", location: "Boston", date: "2025-02-17", requester: "Coach Larry", relation: "Cousin" },
  { id: 49, sport: "Rugby", player: "Nathan Kick", age: 24, team: "Stormers", position: "Fly-half", location: "Cape Town", date: "2025-02-18", requester: "Coach Graham", relation: "Uncle" },
  { id: 50, sport: "Basketball", player: "Scott Drive", age: 21, team: "Knicks", position: "Guard", location: "New York", date: "2025-02-19", requester: "Coach John", relation: "Coach" },
  { id: 51, sport: "Hockey", player: "Danny Blade", age: 25, team: "Bruins", position: "Defense", location: "Boston", date: "2025-02-17", requester: "Coach Larry", relation: "Cousin" },
  { id: 52, sport: "Cricket", player: "Anil Pace", age: 24, team: "SRH", position: "Bowler", location: "India", date: "2025-02-10", requester: "Coach Ravi", relation: "Uncle" },
  { id: 53, sport: "Rugby", player: "Ron Ruck", age: 29, team: "Bulls", position: "Wing", location: "South Africa", date: "2025-02-11", requester: "Coach Finn", relation: "Coach" },
  { id: 54, sport: "Soccer", player: "Carlos Foot", age: 20, team: "Inter", position: "Defender", location: "Italy", date: "2025-02-12", requester: "Coach Tony", relation: "Cousin" },
  { id: 55, sport: "Basketball", player: "Dwayne Dunk", age: 22, team: "Heat", position: "Forward", location: "Miami", date: "2025-02-13", requester: "Coach Walt", relation: "Friend" },
  { id: 56, sport: "Baseball", player: "Owen Hit", age: 21, team: "Dodgers", position: "Pitcher", location: "LA", date: "2025-02-14", requester: "Coach Terry", relation: "Coach" },
  { id: 57, sport: "Football (American)", player: "Paul Pass", age: 23, team: "Packers", position: "Cornerback", location: "Wisconsin", date: "2025-02-15", requester: "Coach Mike", relation: "Mentor" },
  { id: 58, sport: "Cricket", player: "Ravi Spin", age: 26, team: "GT", position: "All-Rounder", location: "India", date: "2025-02-16", requester: "Coach Sanjay", relation: "Coach" },
  { id: 59, sport: "Hockey", player: "Danny Blade", age: 25, team: "Bruins", position: "Defense", location: "Boston", date: "2025-02-17", requester: "Coach Larry", relation: "Cousin" },
  { id: 60, sport: "Rugby", player: "Nathan Kick", age: 24, team: "Stormers", position: "Fly-half", location: "Cape Town", date: "2025-02-18", requester: "Coach Graham", relation: "Uncle" },
  { id: 61, sport: "Basketball", player: "Scott Drive", age: 21, team: "Knicks", position: "Guard", location: "New York", date: "2025-02-19", requester: "Coach John", relation: "Coach" },
//   { id: 51, sport: "Football (American)", player: "John", age: 20, team: "Team A", position: "Forward", location: "NY", date: "2025-01-01", requester: "Coach", relation: "Mentor" },
{ id: 62, sport: "Football (American)", player: "Paul Pass", age: 23, team: "Packers", position: "Cornerback", location: "Wisconsin", date: "2025-02-15", requester: "Coach Mike", relation: "Mentor" },
  // ... 100+ rows from different sports
]; */

const flattenGroupedData = (grouped) => {
  const flat = [];
  for (const [sport, rows] of grouped) {
    for (const row of rows) {
      flat.push({ sport, row });
    }
  }
  return flat;
};

const paginateFlatRows = (flatRows, pageSize = 50) => {
  const pages = [];
  let currentPage = [];
  let currentSport = null;
  let currentRows = [];

  for (let i = 0; i < flatRows.length; i++) {
    const { sport, row } = flatRows[i];

    if (currentSport !== sport) {
      if (currentRows.length > 0) {
        currentPage.push({ sport: currentSport, rows: currentRows });
        currentRows = [];
      }
      currentSport = sport;
    }

    currentRows.push(row);

    const rowCount = currentPage.reduce((sum, s) => sum + s.rows.length, 0) + currentRows.length;
    if (rowCount >= pageSize || i === flatRows.length - 1) {
      currentPage.push({ sport: currentSport, rows: currentRows });
      pages.push(currentPage);
      currentPage = [];
      currentRows = [];
      currentSport = null;
    }
  }

  return pages;
};

// === Grid Renderer
const CategoryGrid = ({ title, rows }) => (
  <div className="category-section">
    <div className="category-title">{title}</div>
    <div className="grid-wrapper">
      <DataGrid
        rows={rows}
        columns={columns}
       autoHeight
        hideFooter
        disableColumnMenu
        disableColumnFilter
        disableSelectionOnClick
        getRowId={(row) => row.id}
        sx={{ '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold' } }}
      />
    </div>
  </div>
);

// === Main Component
const ViewScoutingRequests = () => {
  const { id } = useParams();
  const selectedSport = id ? sportMap[id] : "All";
const [isLoading, setIsLoading] = useState(true);
  const[scoutingData,setScoutingData] = useState({});
 
 
   const app_url = configData.APP_URL;
 useEffect(() => {
    Promise.all([
    retrieveScoutingrequestlist(),
   
     ]).then(() => {
     
      setIsLoading(false);
     
     });
    
    
  },[]);
  async function retrieveScoutingrequestlist() {
    
   
    const response = await fetch(
      app_url+'smwwscout/scoutingrequestlist',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
       console.log(scoutingData)
      setScoutingData(responsedata.data.result);
    }
 
  }
 const handleClick = async (value) => {
   try {
         setIsLoading(true);
      const response = await fetch(
      app_url+'smwwscout/scoutingrequestlist?sport='+value,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
       console.log(scoutingData)
      setScoutingData(responsedata.data.result);
      setPage(1);
    }
       }catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };
   const filteredData =
    selectedSport === "All"
      ? scoutingData
      : scoutingData.filter((d) => d.sport === selectedSport);

  const grouped = new Map();
   if (Array.isArray(filteredData)) {
  for (const row of filteredData) {
    if (!grouped.has(row.sport)) grouped.set(row.sport, []);
    grouped.get(row.sport).push(row);
  }
}
//  const pages = paginateFlatRows(flattenGroupedData(grouped), 50);
// get array of grouped entries (sport string, rows array)
const sortedGroupedEntries = Array.from(grouped.entries())
  .sort(([sportA], [sportB]) => {
    return sportOrder.indexOf(sportA) - sportOrder.indexOf(sportB);
  });

// then flatten + paginate
const pages = paginateFlatRows(flattenGroupedData(sortedGroupedEntries), 50);

  const [page, setPage] = useState(1);

  return (
    <>
       {isLoading ? (
            <Loading />
          ) : (
    <div id="main" className="scouting-request-main">
      <Helmet><title>Scouting Requests</title></Helmet>
      <div className="left"></div>
      <div className="scouting-request-center">
        <div className="scouting-request-container">
          <div className="view-header">
            <p>
              <a href onClick={()=>handleClick("All")} style={{cursor:'pointer'}}>ALL</a>
              {Object.entries(sportMap).map(([key, sport]) => (
                <React.Fragment key={key}>
                  &nbsp;|&nbsp;
                 <a href style={{cursor:'pointer'}} onClick={()=>handleClick(key)}>{sport}</a>
                </React.Fragment>
              ))}
            </p>
          </div>

          <div className="scouting-tables">
            {pages[page - 1]?.map(({ sport, rows }, idx) => (
              <CategoryGrid
                key={`${sport}-${rows[0]?.id}-${idx}`}
                title={`Player's Sport: ${sport}`}
                rows={rows}
              />
            ))}
          </div>

          <Box display="flex" justifyContent="center" mt={2}>
            <Pagination
              count={pages.length}
              page={page}
              onChange={(_, val) => {setPage(val);window.scrollTo(0,0);}}
              color="primary"
            />
          </Box>
        </div>
      </div>
    
    </div>
    
  )}
  </>
);
};

export default ViewScoutingRequests;